type rgb = { r: number; g: number; b: number };

export function hexToRgb(hex: string, output: 'string'): string;
export function hexToRgb(hex: string, output: 'object'): rgb;
export function hexToRgb(hex: string, output: 'string' | 'object'): rgb | string | null {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const formatHex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(formatHex);

  if (!result) {
    return null;
  }

  switch (output) {
    case 'object':
      return {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }; 
    case 'string':
      return `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`;
    default:
      throw new Error(`You've passed in "${output}" which is not a valid output`);
  }
};

